var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c("v-card", { attrs: { flat: "" } }, [
        _c("div", { attrs: { id: "controlsContainer" } }, [
          _c(
            "div",
            {
              staticClass:
                "card-title table-controls px-3 d-flex align-center justify-space-between"
            },
            [
              _c("div"),
              _c(
                "div",
                [
                  _c(
                    "v-container",
                    { attrs: { id: "filterContainer" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { sm: "12", lg: "3", cols: "12" } },
                            [
                              _c(
                                "v-dialog",
                                {
                                  attrs: {
                                    "close-on-content-click": false,
                                    persistent: "",
                                    width: "290px"
                                  },
                                  on: {
                                    keydown: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "esc",
                                          27,
                                          $event.key,
                                          ["Esc", "Escape"]
                                        )
                                      )
                                        return null
                                      _vm.modalFilterDateFrom = false
                                    }
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function({ on }) {
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "timeSlotsReservations.dateFrom"
                                                  ),
                                                  "append-icon":
                                                    "far fa-calendar-alt",
                                                  readonly: "",
                                                  clearable: "",
                                                  required: ""
                                                },
                                                on: {
                                                  "click:clear": function(
                                                    $event
                                                  ) {
                                                    _vm.filter.dateFrom = null
                                                  }
                                                },
                                                model: {
                                                  value: _vm.dateFromFormatted,
                                                  callback: function($$v) {
                                                    _vm.dateFromFormatted = $$v
                                                  },
                                                  expression:
                                                    "dateFromFormatted"
                                                }
                                              },
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.modalFilterDateFrom,
                                    callback: function($$v) {
                                      _vm.modalFilterDateFrom = $$v
                                    },
                                    expression: "modalFilterDateFrom"
                                  }
                                },
                                [
                                  _c(
                                    "v-date-picker",
                                    {
                                      attrs: { scrollable: "" },
                                      on: {
                                        input: function($event) {
                                          _vm.modalFilterDateFrom = false
                                        }
                                      },
                                      model: {
                                        value: _vm.filter.dateFrom,
                                        callback: function($$v) {
                                          _vm.$set(_vm.filter, "dateFrom", $$v)
                                        },
                                        expression: "filter.dateFrom"
                                      }
                                    },
                                    [
                                      _c("v-spacer"),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { text: "", color: "primary" },
                                          on: {
                                            click: function($event) {
                                              _vm.modalFilterDateFrom = false
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("global.cancel")) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { sm: "12", lg: "3", cols: "12" } },
                            [
                              _c(
                                "v-dialog",
                                {
                                  attrs: {
                                    "close-on-content-click": false,
                                    persistent: "",
                                    width: "290px"
                                  },
                                  on: {
                                    keydown: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "esc",
                                          27,
                                          $event.key,
                                          ["Esc", "Escape"]
                                        )
                                      )
                                        return null
                                      _vm.modalFilterDateTo = false
                                    }
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function({ on }) {
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "timeSlotsReservations.dateTo"
                                                  ),
                                                  "append-icon":
                                                    "far fa-calendar-alt",
                                                  readonly: "",
                                                  clearable: "",
                                                  required: ""
                                                },
                                                on: {
                                                  "click:clear": function(
                                                    $event
                                                  ) {
                                                    _vm.filter.dateTo = null
                                                  }
                                                },
                                                model: {
                                                  value: _vm.dateToFormatted,
                                                  callback: function($$v) {
                                                    _vm.dateToFormatted = $$v
                                                  },
                                                  expression: "dateToFormatted"
                                                }
                                              },
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.modalFilterDateTo,
                                    callback: function($$v) {
                                      _vm.modalFilterDateTo = $$v
                                    },
                                    expression: "modalFilterDateTo"
                                  }
                                },
                                [
                                  _c(
                                    "v-date-picker",
                                    {
                                      attrs: { scrollable: "" },
                                      on: {
                                        input: function($event) {
                                          _vm.modalFilterDateTo = false
                                        }
                                      },
                                      model: {
                                        value: _vm.filter.dateTo,
                                        callback: function($$v) {
                                          _vm.$set(_vm.filter, "dateTo", $$v)
                                        },
                                        expression: "filter.dateTo"
                                      }
                                    },
                                    [
                                      _c("v-spacer"),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { text: "", color: "primary" },
                                          on: {
                                            click: function($event) {
                                              _vm.modalFilterDateTo = false
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("global.cancel")) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { sm: "12", lg: "3", cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t(
                                    "timeSlotsReservations.shippingNumber"
                                  ),
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.filter.shippingNumber,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "shippingNumber", $$v)
                                  },
                                  expression: "filter.shippingNumber"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { sm: "12", lg: "3", cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t(
                                    "timeSlotsReservations.tokenTracking"
                                  ),
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.filter.tokenTracking,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "tokenTracking", $$v)
                                  },
                                  expression: "filter.tokenTracking"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { sm: "12", lg: "4", cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t(
                                    "timeSlotsReservations.reference"
                                  ),
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.filter.reference,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "reference", $$v)
                                  },
                                  expression: "filter.reference"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { sm: "12", lg: "4", cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t(
                                    "timeSlotsReservations.consigneeName"
                                  ),
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.filter.consigneeName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "consigneeName", $$v)
                                  },
                                  expression: "filter.consigneeName"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { sm: "12", lg: "4", cols: "12" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.reservationTypeValues,
                                  label: _vm.$t("timeSlotsReservations.type"),
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.filter.reservationType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "reservationType", $$v)
                                  },
                                  expression: "filter.reservationType"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("crud-button", {
                    attrs: {
                      large: "",
                      color: "blue",
                      icon: "fa-sync-alt",
                      tooltip: _vm.$t("global.crud.buttons.refreshTable")
                    },
                    on: {
                      clicked: function($event) {
                        return _vm.search()
                      }
                    }
                  })
                ],
                1
              ),
              _c("ExportExcel", {
                attrs: {
                  url: "/timeSlotsReservations",
                  filter: this.filter,
                  filterExport: _vm.filterExport,
                  processFilter: _vm.processFilter,
                  itemsPerPage: 10000
                }
              })
            ],
            1
          )
        ]),
        _c(
          "div",
          { attrs: { id: "dataContainer" } },
          [
            _c("v-data-table", {
              attrs: {
                headers: _vm.headers,
                items: _vm.items,
                options: _vm.options,
                page: _vm.pagination.page,
                "server-items-length": _vm.pagination.totalItems,
                "no-results-text": _vm.$t("global.datatable.noMatchingResults"),
                "no-data-text": _vm.$t("global.datatable.noDataAvailable"),
                "footer-props": {
                  "items-per-page-options": _vm.rowsPerPageItems,
                  "show-first-last-page": true,
                  "show-current-page": true
                },
                loading: _vm.loading,
                light: "",
                "multi-sort": "",
                dense: ""
              },
              on: {
                "update:options": function($event) {
                  _vm.options = $event
                },
                "update:page": function($event) {
                  return _vm.$set(_vm.pagination, "page", $event)
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function({ items }) {
                    return [
                      _c(
                        "tbody",
                        _vm._l(items, function(item) {
                          return _c("tr", { key: item.token }, [
                            _c(
                              "td",
                              [
                                _vm.$checkPermission("TIMESLOTSRESERVATIONS") &&
                                item.tokenTracking &&
                                item.countryReservation &&
                                item.postalCodeReservation
                                  ? _c("crud-button", {
                                      attrs: {
                                        "x-small": "",
                                        color: "orange",
                                        icon: "fa-calendar-alt",
                                        tooltip: _vm.$t(
                                          "timeSlotsReservations.reschedule"
                                        )
                                      },
                                      on: {
                                        clicked: function($event) {
                                          return _vm.reschedule(item)
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c("td", [_vm._v(_vm._s(item.shippingNumber))]),
                            _c("td", [_vm._v(_vm._s(item.reference))]),
                            _c("td", [_vm._v(_vm._s(item.tokenTracking))]),
                            _c("td", [_vm._v(_vm._s(item.token))]),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.transformDate(
                                    item.date,
                                    _vm.$t("global.dateFormat")
                                  )
                                )
                              )
                            ]),
                            _c("td", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.minutesToHour(item.hourFrom)) +
                                  " - " +
                                  _vm._s(_vm.minutesToHour(item.hourTo)) +
                                  " "
                              )
                            ]),
                            _c("td", [
                              _vm._v(
                                _vm._s(_vm.minutesFormat(item.deliveryTime))
                              )
                            ]),
                            _c("td", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.transformDate(
                                      item.creationDate,
                                      _vm.$t("global.dateTimeFormat")
                                    )
                                  ) +
                                  " "
                              )
                            ]),
                            _c("td", [_vm._v(_vm._s(item.reservationUser))]),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.getReservationTypeText(
                                    item.reservationType
                                  )
                                )
                              )
                            ]),
                            _c("td", [
                              item.trackingUrl
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: item.trackingUrl,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "timeSlotsReservations.tracking"
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ])
                        }),
                        0
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ]),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "800",
            persistent: "",
            "no-click-animation": ""
          },
          model: {
            value: _vm.rescheduleDialog,
            callback: function($$v) {
              _vm.rescheduleDialog = $$v
            },
            expression: "rescheduleDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", dense: "", flat: "" } },
                [
                  _c("v-toolbar-title", { staticClass: "white--text" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("timeSlotsReservations.reschedule.title")
                        ) +
                        " "
                    )
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.closeReschedule()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("fas fa-times")])],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "details-list" },
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-row",
                        [
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c("h3", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.selectedItem.shippingNumber) +
                                  " - " +
                                  _vm._s(_vm.selectedItem.reference) +
                                  " "
                              )
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm.availableSlots.length > 0
                        ? _c(
                            "div",
                            [
                              _vm._l(_vm.availableSlots, function(
                                dateGroup,
                                index
                              ) {
                                return [
                                  _c(
                                    "v-row",
                                    { key: index },
                                    [
                                      _c(
                                        "v-col",
                                        [
                                          _c(
                                            "v-card",
                                            {
                                              staticClass: "grey lighten-3",
                                              attrs: { outlined: "" }
                                            },
                                            [
                                              _c(
                                                "v-card-text",
                                                [
                                                  _c(
                                                    "v-row",
                                                    {
                                                      attrs: { align: "center" }
                                                    },
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: {
                                                            cols: "auto"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "time",
                                                            {
                                                              staticClass:
                                                                "icon",
                                                              attrs: {
                                                                datetime:
                                                                  dateGroup.date
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "em",
                                                                {
                                                                  staticClass:
                                                                    "blue--text"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$d(
                                                                          Date.parse(
                                                                            dateGroup.date
                                                                          ),
                                                                          "dayText"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "strong",
                                                                {
                                                                  staticClass:
                                                                    "primary white--text"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$d(
                                                                          Date.parse(
                                                                            dateGroup.date
                                                                          ),
                                                                          "monthText"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  )
                                                                ]
                                                              ),
                                                              _c("span", [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$d(
                                                                        Date.parse(
                                                                          dateGroup.date
                                                                        ),
                                                                        "dayShort"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._l(
                                                        dateGroup.rangeList,
                                                        function(range) {
                                                          return [
                                                            _c(
                                                              "v-col",
                                                              {
                                                                key: range.code,
                                                                attrs: {
                                                                  cols: "auto"
                                                                }
                                                              },
                                                              [
                                                                _c("v-hover", {
                                                                  scopedSlots: _vm._u(
                                                                    [
                                                                      {
                                                                        key:
                                                                          "default",
                                                                        fn: function({
                                                                          hover
                                                                        }) {
                                                                          return [
                                                                            _c(
                                                                              "v-card",
                                                                              {
                                                                                staticStyle: {
                                                                                  cursor:
                                                                                    "pointer"
                                                                                },
                                                                                attrs: {
                                                                                  elevation: hover
                                                                                    ? 12
                                                                                    : 2,
                                                                                  color:
                                                                                    _vm.selectedSlot &&
                                                                                    _vm
                                                                                      .selectedSlot
                                                                                      .code ===
                                                                                      range.code &&
                                                                                    _vm
                                                                                      .selectedSlot
                                                                                      .date ===
                                                                                      dateGroup.date
                                                                                      ? "primary"
                                                                                      : "default"
                                                                                },
                                                                                nativeOn: {
                                                                                  click: function(
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.selectSlot(
                                                                                      range,
                                                                                      dateGroup.date
                                                                                    )
                                                                                  }
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-card-text",
                                                                                  {
                                                                                    class:
                                                                                      _vm.selectedSlot &&
                                                                                      _vm
                                                                                        .selectedSlot
                                                                                        .code ===
                                                                                        range.code &&
                                                                                      _vm
                                                                                        .selectedSlot
                                                                                        .date ===
                                                                                        dateGroup.date
                                                                                        ? "white--text"
                                                                                        : ""
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      " " +
                                                                                        _vm._s(
                                                                                          range.dateFrom
                                                                                        ) +
                                                                                        " - " +
                                                                                        _vm._s(
                                                                                          range.dateTo
                                                                                        ) +
                                                                                        " "
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ],
                                                                              1
                                                                            )
                                                                          ]
                                                                        }
                                                                      }
                                                                    ],
                                                                    null,
                                                                    true
                                                                  )
                                                                })
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        }
                                                      )
                                                    ],
                                                    2
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              })
                            ],
                            2
                          )
                        : _vm.loadingSlots
                        ? _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: { cols: "12" }
                                },
                                [
                                  _c("v-progress-circular", {
                                    attrs: {
                                      indeterminate: "",
                                      color: "primary"
                                    }
                                  }),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "timeSlotsReservations.reschedule.loading"
                                        )
                                      )
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: { cols: "12" }
                                },
                                [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "timeSlotsReservations.reschedule.noSlots"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "black", text: "" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.closeReschedule()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("global.buttons.close")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "orange",
                        text: "",
                        disabled: !_vm.selectedSlot
                      },
                      on: {
                        click: function($event) {
                          return _vm.confirmReschedule()
                        }
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("timeSlotsReservations.reschedule.confirm")
                          ) +
                          " "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }